import script from "./ConnectChannelModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConnectChannelModal.vue?vue&type=script&setup=true&lang=ts"

import "./ConnectChannelModal.vue?vue&type=style&index=0&id=471d12e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-471d12e8"]])

export default __exports__